<template lang="pug">
	dx-validation-group.recovery-password.flex-col.space-large.dx-card(:class="{ 'has-token': !!recoveryToken }")
		.login-header.full-width.align-center.flex-col
			img(:src="require('assets/logo_transparent.png')" height="60px")
			div {{$tCaption('Password recovery')}}
		template(v-if="!recoveryToken")
			.flex-col.space-large.flex-basis-200.flex-1.tb-padding
				.flex-col.space(v-if="recoveryLinkIsSent")
					span {{$tCaption('Please click on the link sent to your email address to recover your access to your account.')}}
					span {{$tCaption('If you\'ve not received an email, check your spam folder or request a new link in')}} {{recoveryTimer}} {{$tCaption('seconds')}}.
				template(v-else)
					.font-small.upper.grey {{$tCaption('Enter the email address you initially used to register your account')}}
					dx-text-box(:value.sync="email" :disabled="isLoading" width="100%", placeholder="E-mail")
						dx-validator
							dx-required-rule(:message="$tCaption('Email is required')")
					DxButton(:text="`${$tCaption('Recover password')}${recoveryTimer ? ` (${recoveryTimer})..` : ''}`", @click="onRecoverPassword", :disabled="!!recoveryTimer || isLoading")
				a(@click="$router.push({ name: 'login-form' })") {{$tCaption('Back to login')}}
		template(v-else)
			.flex-col.space-large
				.flex-col.field.space
					.font-small.upper.grey {{$tCaption('Create new password')}}
					dx-text-box(
						:value.sync="password"
						:disabled="isLoading"
						width="100%"
						mode="password"
					)
						dx-validator
							dx-required-rule(:message="$tCaption('Password is required')")
				.flex-col.field.space
					.font-small.upper.grey {{$tCaption('Confirm new password')}}
					dx-text-box(
						:value.sync="passwordAgain"
						:disabled="isLoading"
						width="100%"
						mode="password"
					)
						dx-validator
							dx-required-rule(:message="$tCaption('Confirm new password is required')")
							dx-custom-rule(:validation-callback="() => !!(passwordAgain === password)", :message="$tCaption('Entered values are different')")
				DxButton(:text="$tCaption('Change password')", @click="onChangePassword")
</template>

<script>	
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
	import Loader from 'app-core/Loader.vue';	

	export default {
		translationCategory: 'user.RecoveryPassword',
		name: 'recovery-password',
		components: {
			DxButton, DxTextBox, Loader, DxValidationGroup, DxValidator, DxRequiredRule, DxCustomRule
		},
		data() {
			return {
				email: null,
				recoveryLinkIsSent: false,
				recoveryTimer: 0,
				isLoading: false,
				password: null,
				passwordAgain: null
			};
		},
		computed: {
			recoveryToken() {
				return this.$route.query.recoveryToken;
			}
		},
		watch: {
			recoveryTimer(v) {
				if (v && v > 0)
					setTimeout(() => this.recoveryTimer--, 1000);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.recovery = this;
		},
		methods: {
			onRecoverPassword(e) {
				if (!e.validationGroup.validate().isValid) {					
					return;
				};
				this.isLoading = true;
				this.recoveryLinkIsSent = false;
				this.$Data.getExternalApi('Security/RecoveryPasswordRequest', `email=${this.email}`).then(r => {
					if (r.Success) {
						this.recoveryTimer = 120;
						this.recoveryLinkIsSent = true;
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => this.isLoading = false);
			},
			onChangePassword(e) {
				if (!e.validationGroup.validate().isValid) {					
					return;
				};
				this.isLoading = true;
				this.$Data.getExternalApi('Security/RecoveryPasswordConfirm', `password=${this.password}&token=${this.recoveryToken}`).then(r => {
					if (r.Success) {
						this.$notifySuccess(this.$tCaption('Your password has successfully been changed'));
						this.$router.push({ name: 'login-form' });
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => this.isLoading = false);
			}
		}
	};
</script>
<style lang='scss'>
	.recovery-password {
		max-width: 90vw;		
		width: 470px !important;
		
		&.has-token {
			width: 280px !important;
		}
	}
</style>
 